export const ventajasTranslations = {
    es: {
        ventajas: {
            title: "El Especialista como Decisor Principal",
            description: "La mayor barrera para adoptar Inteligencia Artificial en salud no es algorítmica, es cultural. Diseñamos despliegues que eliminan la fricción integrando las soluciones de manera transparente dentro de la rutina de lectura médica habitual.",
            features: [
                {
                    title: "Apropiación Clínica Efectiva",
                    text: "Orquestamos desde el proxy DICOM hasta la visibilidad en el Visor para que la IA sea recibida como un colega indispensable, no como una imposición técnica."
                },
                {
                    title: "Ecosistema Autoconclusivo y Digno",
                    text: "Acompañamos el arranque y nos aseguramos de que su institución quede plenamente capacitada para operar la arquitectura de forma 100% independiente."
                }
            ]
        }
    },
    en: {
        ventajas: {
            title: "The Specialist as Primary Decision Maker",
            description: "The biggest barrier to adopting Artificial Intelligence in health is not algorithmic, it's cultural. We design deployments that eliminate friction by integrating solutions seamlessly within the regular medical reading routine.",
            features: [
                {
                    title: "Effective Clinical Ownership",
                    text: "We orchestrate from the DICOM proxy to viewer visibility so that AI is received as an indispensable colleague, not a technical imposition."
                },
                {
                    title: "Self-Sufficient and Digno Ecosystem",
                    text: "We accompany the startup and ensure your institution remains fully capable of operating the architecture independently."
                }
            ]
        }
    }
};
